module.exports = __webpack_public_path__ + "static/media/Grafikai elemek.090a12e8.svg";